module.exports = __webpack_public_path__ + "img/userA01.27cf7695.jpg";